/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getOpProcedureOrders } from 'app/entities/op-procedure-order/op-procedure-order.reducer';
import { getEntities as getHospitalProcedures } from 'app/entities/hospital-procedure/hospital-procedure.reducer';
import { getEntities as getDentalExamAndTreatments } from 'app/entities/dental-exam-and-treatment/dental-exam-and-treatment.reducer';
import { getEntities as getDentalMouthItems } from 'app/entities/dental-mouth-item/dental-mouth-item.reducer';
import { getEntities as getDentalSurfaces } from 'app/entities/dental-surface/dental-surface.reducer';
import { OrderStatus } from 'app/shared/model/enumerations/order-status.model';
import { ProcedureStatus } from 'app/shared/model/enumerations/procedure-status.model';
import { createEntity, getEntity, reset, updateEntity } from './op-procedure-order-item.reducer';

export const OpProcedureOrderItemUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const opProcedureOrders = useAppSelector(state => state.opProcedureOrder.entities);
  const hospitalProcedures = useAppSelector(state => state.hospitalProcedure.entities);
  const dentalExamAndTreatments = useAppSelector(state => state.dentalExamAndTreatment.entities);
  const dentalMouthItems = useAppSelector(state => state.dentalMouthItem.entities);
  const dentalSurfaces = useAppSelector(state => state.dentalSurface.entities);
  const opProcedureOrderItemEntity = useAppSelector(state => state.opProcedureOrderItem.entity);
  const loading = useAppSelector(state => state.opProcedureOrderItem.loading);
  const updating = useAppSelector(state => state.opProcedureOrderItem.updating);
  const updateSuccess = useAppSelector(state => state.opProcedureOrderItem.updateSuccess);
  const orderStatusValues = Object.keys(OrderStatus);
  const procedureStatusValues = Object.keys(ProcedureStatus);

  const handleClose = () => {
    navigate(`/op-procedure-order-item${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getOpProcedureOrders({}));
    dispatch(getHospitalProcedures({}));
    dispatch(getDentalExamAndTreatments({}));
    dispatch(getDentalMouthItems({}));
    dispatch(getDentalSurfaces({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.totalCost !== undefined && typeof values.totalCost !== 'number') {
      values.totalCost = Number(values.totalCost);
    }

    const entity = {
      ...opProcedureOrderItemEntity,
      ...values,
      order: opProcedureOrders.find(it => it.id.toString() === values.order?.toString()),
      procedure: hospitalProcedures.find(it => it.id.toString() === values.procedure?.toString()),
      exam: dentalExamAndTreatments.find(it => it.id.toString() === values.exam?.toString()),
      tooth: dentalMouthItems.find(it => it.id.toString() === values.tooth?.toString()),
      surface: dentalSurfaces.find(it => it.id.toString() === values.surface?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          orderStatus: 'CREATED',
          procedureStatus: 'PLANNED',
          ...opProcedureOrderItemEntity,
          order: opProcedureOrderItemEntity?.order?.id,
          procedure: opProcedureOrderItemEntity?.procedure?.id,
          exam: opProcedureOrderItemEntity?.exam?.id,
          tooth: opProcedureOrderItemEntity?.tooth?.id,
          surface: opProcedureOrderItemEntity?.surface?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.opProcedureOrderItem.home.createOrEditLabel" data-cy="OpProcedureOrderItemCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.opProcedureOrderItem.home.createOrEditLabel">
              Create or edit a OpProcedureOrderItem
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="op-procedure-order-item-id"
                  label={translate('tinyMedicRestApp.opProcedureOrderItem.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.opProcedureOrderItem.active')}
                id="op-procedure-order-item-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.opProcedureOrderItem.microSec')}
                id="op-procedure-order-item-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.opProcedureOrderItem.timestampEntry')}
                id="op-procedure-order-item-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.opProcedureOrderItem.lastUpdated')}
                id="op-procedure-order-item-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.opProcedureOrderItem.cursor')}
                id="op-procedure-order-item-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.opProcedureOrderItem.totalCost')}
                id="op-procedure-order-item-totalCost"
                name="totalCost"
                data-cy="totalCost"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.opProcedureOrderItem.notes')}
                id="op-procedure-order-item-notes"
                name="notes"
                data-cy="notes"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.opProcedureOrderItem.orderStatus')}
                id="op-procedure-order-item-orderStatus"
                name="orderStatus"
                data-cy="orderStatus"
                type="select"
              >
                {orderStatusValues.map(orderStatus => (
                  <option value={orderStatus} key={orderStatus}>
                    {translate(`tinyMedicRestApp.OrderStatus.${orderStatus}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.opProcedureOrderItem.procedureStatus')}
                id="op-procedure-order-item-procedureStatus"
                name="procedureStatus"
                data-cy="procedureStatus"
                type="select"
              >
                {procedureStatusValues.map(procedureStatus => (
                  <option value={procedureStatus} key={procedureStatus}>
                    {translate(`tinyMedicRestApp.ProcedureStatus.${procedureStatus}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                id="op-procedure-order-item-order"
                name="order"
                data-cy="order"
                label={translate('tinyMedicRestApp.opProcedureOrderItem.order')}
                type="select"
                required
              >
                <option value="" key="0" />
                {opProcedureOrders
                  ? opProcedureOrders.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="op-procedure-order-item-procedure"
                name="procedure"
                data-cy="procedure"
                label={translate('tinyMedicRestApp.opProcedureOrderItem.procedure')}
                type="select"
              >
                <option value="" key="0" />
                {hospitalProcedures
                  ? hospitalProcedures.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="op-procedure-order-item-exam"
                name="exam"
                data-cy="exam"
                label={translate('tinyMedicRestApp.opProcedureOrderItem.exam')}
                type="select"
              >
                <option value="" key="0" />
                {dentalExamAndTreatments
                  ? dentalExamAndTreatments.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="op-procedure-order-item-tooth"
                name="tooth"
                data-cy="tooth"
                label={translate('tinyMedicRestApp.opProcedureOrderItem.tooth')}
                type="select"
              >
                <option value="" key="0" />
                {dentalMouthItems
                  ? dentalMouthItems.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="op-procedure-order-item-surface"
                name="surface"
                data-cy="surface"
                label={translate('tinyMedicRestApp.opProcedureOrderItem.surface')}
                type="select"
              >
                <option value="" key="0" />
                {dentalSurfaces
                  ? dentalSurfaces.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/op-procedure-order-item" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default OpProcedureOrderItemUpdate;
